function getAdInfoDialog() {
  return `
    <div class="ad-info_dialog-modal-padding">
    <section>
    <h2 class="ad-info_dialog-header" autofocus>Om annonser på Bonnier News</h2>
    <p class="ad-info_dialog-text">Våra sajter är delvis annonsfinansierade.</p>
    <a target="_blank" href="https://privacy.bonniernews.se/vanliga-fragor/" class="ad-info_dialog-link">Läs mer om våra annonser
    <span class="ad-info_dialog_external_symbol"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17 13.5v6H5v-12h6m3-3h6v6m0-6-9 9" stroke="#666" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
    </a>
    </section>

    <section id="ad-info_dialog-section-report">
    <h2 class="ad-info_dialog-header">Rapportera annons</h2>
    <p class="ad-info_dialog-text">Inloggade användare har möjlighet att rapportera en annons som anses olämplig eller är en bluffannons.</p>
    <button id="dialog-report-button" class="ad-info_dialog-button">Rapportera annons</button>
    </section>

    <button id="dialog-cancel-button" class="ad-info_dialog-cancel-button">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"/>
    </svg>
    </button>

    <svg class="ad-info_dialog-logo" width="128" height="12" viewBox="0 0 128 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M118.27 8.2314V10.9421C119.212 11.6529 121.179 12 122.501 12C125.047 12 127.212 10.8264 127.212 8.38016C127.212 6.31405 125.642 5.50413 124.287 5.10744L122.171 4.49587C121.444 4.28099 120.948 3.98347 120.948 3.38843C120.948 2.66116 121.807 2.19835 122.832 2.19835C124.472 2.19835 125.344 2.73964 126.095 3.20557C126.132 3.22816 126.168 3.25057 126.204 3.27273V0.561983C125.262 0.181818 124.171 0 122.799 0C120.518 0 118.419 1.33884 118.419 3.4876C118.419 5.47107 119.774 6.2314 121.245 6.66116L123.377 7.28926C124.237 7.53719 124.7 7.85124 124.7 8.49587C124.7 9.2562 123.923 9.80165 122.468 9.80165C121.163 9.80165 119.559 9.20661 118.27 8.2314ZM0 0.231391H5.3719C6.69421 0.231391 7.73554 0.595027 8.39669 1.25618C8.92562 1.78511 9.19008 2.42974 9.19008 3.22313V3.25618C9.19008 4.56197 8.49587 5.28924 7.66942 5.75205C9.00826 6.26445 9.83471 7.04131 9.83471 8.59503V8.62808C9.83471 10.7438 8.1157 11.8016 5.50413 11.8016H0V0.231391ZM4.82645 4.90908C5.95041 4.90908 6.66116 4.54544 6.66116 3.68594V3.65288C6.66116 2.89255 6.06611 2.4628 4.99173 2.4628H2.47934V4.90908H4.82645ZM5.50413 9.57023C6.6281 9.57023 7.30578 9.17354 7.30578 8.31403V8.28098C7.30578 7.50412 6.72727 7.02478 5.42149 7.02478H2.47934V9.57023H5.50413ZM10.7273 6.04957V6.01651C10.7273 2.72726 13.3223 0.0330439 16.8926 0.0330439C20.4628 0.0330439 23.0248 2.6942 23.0248 5.98346V6.01651C23.0248 9.30577 20.4297 12 16.8595 12C13.2893 12 10.7273 9.33883 10.7273 6.04957ZM20.3636 6.04957V6.01651C20.3636 4.03304 18.9091 2.38015 16.8595 2.38015C14.8099 2.38015 13.3884 3.99999 13.3884 5.98346V6.01651C13.3884 7.99998 14.843 9.65288 16.8926 9.65288C18.9421 9.65288 20.3636 8.03304 20.3636 6.04957ZM26.7603 0.231391L32.1818 7.35536V0.231391H34.6942V11.8016H32.4132L26.9256 4.61156V11.8016H24.4132V1.76858L23.2397 0.231391H26.7603ZM39.5041 0.231391L44.9256 7.35536V0.231391H47.438V11.8016H45.157L39.6694 4.61156V11.8016H37.157V1.76858L35.9835 0.231391H39.5041ZM49.8512 0.231391H52.3967V11.8016H49.8512V0.231391ZM54.8595 0.231391H63.5868V2.49585H57.3884V4.84296H62.843V7.10742H57.3884V9.53718H63.6694V11.8016H54.8595V0.231391ZM65.2231 0.231391H70.5124C71.9835 0.231391 73.124 0.644614 73.8843 1.40494C74.5289 2.04957 74.876 2.95866 74.876 4.04957V4.08263C74.876 5.99999 73.8182 7.22313 72.2645 7.76858L75.3388 11.8016H72.2975L67.7686 5.85122H70.3471C71.5868 5.85122 72.2975 5.19007 72.2975 4.21486V4.1818C72.2975 3.09089 71.5372 2.52891 70.2975 2.52891H67.7686V5.85122V11.8016H65.2231V0.231391ZM80.3634 1.76859L79.1899 0.231396H82.7105L88.132 7.35536V0.231396H90.6444V11.8016H88.3634L82.8758 4.61156V11.8016H80.3634V1.76859ZM101.413 0.231396H92.686V11.8016H101.496V9.53718H95.215V7.10743H100.67V4.84297H95.215V2.49586H101.413V0.231396ZM102.083 0.231396H104.859L107.223 8.38015L108.925 2.74379L108.116 0.231396H110.843L113.19 8.09916L115.487 0.231396H118.066L114.479 11.8016H111.835L110.066 6.29751L108.314 11.8016H105.669L102.083 0.231396Z"/>
    </svg>
    </div>
  `;
}

function getAdInfoReportDialog() {
  return `
    <div class="ad-info_dialog-modal-padding">
    <h2 class="ad-info_dialog-header">Rapportera annons</h2>
    <p class="ad-info_dialog-text">Välj anledningen till varför du vill rapportera denna annonsen.</p>

    <form id="dialog-report-form" method="dialog">
    <div>
    <input autofocus type="radio" id="olamplig" name="reason" value="olamplig" required>
    <label for="olamplig">
    <p>Den har ett olämpligt innehåll</p>
    <p class="ad-info_dialog-text-small">Det kan vara våld, droger eller erotisktrelaterat innehåll.</p>
    </label>
    </div>
    <div>
    <input type="radio" id="bluff" name="reason" value="bluff">
    <label for="bluff">
    <p>Det är en bluffannons</p>
    <p class="ad-info_dialog-text-small">Det kan vara potentiella bedragare med syfte att luras eller avskräcka besökare.</p>
    </label>
    </div>
    <p class="ad-info_dialog-text-small" id="ad-info_dialog_screenshot_info" hidden>För att kunna granska annonsen kommer verktyget att behöva ta en skärmbild av den aktuella annonsen. Aktuell yta och godkännande av detta sker i nästa steg. Det finns ingen information som sparas om dig som användare.</p>
    <button id="dialog-report-submit-button" class="ad-info_dialog-button">Skicka</button>
    </form>

    <button id="dialog-report-cancel-button" class="ad-info_dialog-cancel-button">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"/>
    </svg>
    </button>

    <svg class="ad-info_dialog-logo" width="128" height="12" viewBox="0 0 128 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M118.27 8.2314V10.9421C119.212 11.6529 121.179 12 122.501 12C125.047 12 127.212 10.8264 127.212 8.38016C127.212 6.31405 125.642 5.50413 124.287 5.10744L122.171 4.49587C121.444 4.28099 120.948 3.98347 120.948 3.38843C120.948 2.66116 121.807 2.19835 122.832 2.19835C124.472 2.19835 125.344 2.73964 126.095 3.20557C126.132 3.22816 126.168 3.25057 126.204 3.27273V0.561983C125.262 0.181818 124.171 0 122.799 0C120.518 0 118.419 1.33884 118.419 3.4876C118.419 5.47107 119.774 6.2314 121.245 6.66116L123.377 7.28926C124.237 7.53719 124.7 7.85124 124.7 8.49587C124.7 9.2562 123.923 9.80165 122.468 9.80165C121.163 9.80165 119.559 9.20661 118.27 8.2314ZM0 0.231391H5.3719C6.69421 0.231391 7.73554 0.595027 8.39669 1.25618C8.92562 1.78511 9.19008 2.42974 9.19008 3.22313V3.25618C9.19008 4.56197 8.49587 5.28924 7.66942 5.75205C9.00826 6.26445 9.83471 7.04131 9.83471 8.59503V8.62808C9.83471 10.7438 8.1157 11.8016 5.50413 11.8016H0V0.231391ZM4.82645 4.90908C5.95041 4.90908 6.66116 4.54544 6.66116 3.68594V3.65288C6.66116 2.89255 6.06611 2.4628 4.99173 2.4628H2.47934V4.90908H4.82645ZM5.50413 9.57023C6.6281 9.57023 7.30578 9.17354 7.30578 8.31403V8.28098C7.30578 7.50412 6.72727 7.02478 5.42149 7.02478H2.47934V9.57023H5.50413ZM10.7273 6.04957V6.01651C10.7273 2.72726 13.3223 0.0330439 16.8926 0.0330439C20.4628 0.0330439 23.0248 2.6942 23.0248 5.98346V6.01651C23.0248 9.30577 20.4297 12 16.8595 12C13.2893 12 10.7273 9.33883 10.7273 6.04957ZM20.3636 6.04957V6.01651C20.3636 4.03304 18.9091 2.38015 16.8595 2.38015C14.8099 2.38015 13.3884 3.99999 13.3884 5.98346V6.01651C13.3884 7.99998 14.843 9.65288 16.8926 9.65288C18.9421 9.65288 20.3636 8.03304 20.3636 6.04957ZM26.7603 0.231391L32.1818 7.35536V0.231391H34.6942V11.8016H32.4132L26.9256 4.61156V11.8016H24.4132V1.76858L23.2397 0.231391H26.7603ZM39.5041 0.231391L44.9256 7.35536V0.231391H47.438V11.8016H45.157L39.6694 4.61156V11.8016H37.157V1.76858L35.9835 0.231391H39.5041ZM49.8512 0.231391H52.3967V11.8016H49.8512V0.231391ZM54.8595 0.231391H63.5868V2.49585H57.3884V4.84296H62.843V7.10742H57.3884V9.53718H63.6694V11.8016H54.8595V0.231391ZM65.2231 0.231391H70.5124C71.9835 0.231391 73.124 0.644614 73.8843 1.40494C74.5289 2.04957 74.876 2.95866 74.876 4.04957V4.08263C74.876 5.99999 73.8182 7.22313 72.2645 7.76858L75.3388 11.8016H72.2975L67.7686 5.85122H70.3471C71.5868 5.85122 72.2975 5.19007 72.2975 4.21486V4.1818C72.2975 3.09089 71.5372 2.52891 70.2975 2.52891H67.7686V5.85122V11.8016H65.2231V0.231391ZM80.3634 1.76859L79.1899 0.231396H82.7105L88.132 7.35536V0.231396H90.6444V11.8016H88.3634L82.8758 4.61156V11.8016H80.3634V1.76859ZM101.413 0.231396H92.686V11.8016H101.496V9.53718H95.215V7.10743H100.67V4.84297H95.215V2.49586H101.413V0.231396ZM102.083 0.231396H104.859L107.223 8.38015L108.925 2.74379L108.116 0.231396H110.843L113.19 8.09916L115.487 0.231396H118.066L114.479 11.8016H111.835L110.066 6.29751L108.314 11.8016H105.669L102.083 0.231396Z"/>
    </svg>
    </div>
  `;
}

function getReportSuccessDialog() {
  return `
    <div class="ad-info_dialog-modal-padding">
    <h2 class="ad-info_dialog-header" autofocus>Annonsen är rapporterad</h2>
    <p class="ad-info_dialog-text">Tack för att du hjälper oss att uppmärksamma felaktiga annonser!</p>
    <button id="dialog-success-report-button" class="ad-info_dialog-button">Stäng</button>

    <button id="dialog-success-cancel-button" class="ad-info_dialog-cancel-button">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"/>
    </svg>
    </button>

    <svg class="ad-info_dialog-logo" width="128" height="12" viewBox="0 0 128 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M118.27 8.2314V10.9421C119.212 11.6529 121.179 12 122.501 12C125.047 12 127.212 10.8264 127.212 8.38016C127.212 6.31405 125.642 5.50413 124.287 5.10744L122.171 4.49587C121.444 4.28099 120.948 3.98347 120.948 3.38843C120.948 2.66116 121.807 2.19835 122.832 2.19835C124.472 2.19835 125.344 2.73964 126.095 3.20557C126.132 3.22816 126.168 3.25057 126.204 3.27273V0.561983C125.262 0.181818 124.171 0 122.799 0C120.518 0 118.419 1.33884 118.419 3.4876C118.419 5.47107 119.774 6.2314 121.245 6.66116L123.377 7.28926C124.237 7.53719 124.7 7.85124 124.7 8.49587C124.7 9.2562 123.923 9.80165 122.468 9.80165C121.163 9.80165 119.559 9.20661 118.27 8.2314ZM0 0.231391H5.3719C6.69421 0.231391 7.73554 0.595027 8.39669 1.25618C8.92562 1.78511 9.19008 2.42974 9.19008 3.22313V3.25618C9.19008 4.56197 8.49587 5.28924 7.66942 5.75205C9.00826 6.26445 9.83471 7.04131 9.83471 8.59503V8.62808C9.83471 10.7438 8.1157 11.8016 5.50413 11.8016H0V0.231391ZM4.82645 4.90908C5.95041 4.90908 6.66116 4.54544 6.66116 3.68594V3.65288C6.66116 2.89255 6.06611 2.4628 4.99173 2.4628H2.47934V4.90908H4.82645ZM5.50413 9.57023C6.6281 9.57023 7.30578 9.17354 7.30578 8.31403V8.28098C7.30578 7.50412 6.72727 7.02478 5.42149 7.02478H2.47934V9.57023H5.50413ZM10.7273 6.04957V6.01651C10.7273 2.72726 13.3223 0.0330439 16.8926 0.0330439C20.4628 0.0330439 23.0248 2.6942 23.0248 5.98346V6.01651C23.0248 9.30577 20.4297 12 16.8595 12C13.2893 12 10.7273 9.33883 10.7273 6.04957ZM20.3636 6.04957V6.01651C20.3636 4.03304 18.9091 2.38015 16.8595 2.38015C14.8099 2.38015 13.3884 3.99999 13.3884 5.98346V6.01651C13.3884 7.99998 14.843 9.65288 16.8926 9.65288C18.9421 9.65288 20.3636 8.03304 20.3636 6.04957ZM26.7603 0.231391L32.1818 7.35536V0.231391H34.6942V11.8016H32.4132L26.9256 4.61156V11.8016H24.4132V1.76858L23.2397 0.231391H26.7603ZM39.5041 0.231391L44.9256 7.35536V0.231391H47.438V11.8016H45.157L39.6694 4.61156V11.8016H37.157V1.76858L35.9835 0.231391H39.5041ZM49.8512 0.231391H52.3967V11.8016H49.8512V0.231391ZM54.8595 0.231391H63.5868V2.49585H57.3884V4.84296H62.843V7.10742H57.3884V9.53718H63.6694V11.8016H54.8595V0.231391ZM65.2231 0.231391H70.5124C71.9835 0.231391 73.124 0.644614 73.8843 1.40494C74.5289 2.04957 74.876 2.95866 74.876 4.04957V4.08263C74.876 5.99999 73.8182 7.22313 72.2645 7.76858L75.3388 11.8016H72.2975L67.7686 5.85122H70.3471C71.5868 5.85122 72.2975 5.19007 72.2975 4.21486V4.1818C72.2975 3.09089 71.5372 2.52891 70.2975 2.52891H67.7686V5.85122V11.8016H65.2231V0.231391ZM80.3634 1.76859L79.1899 0.231396H82.7105L88.132 7.35536V0.231396H90.6444V11.8016H88.3634L82.8758 4.61156V11.8016H80.3634V1.76859ZM101.413 0.231396H92.686V11.8016H101.496V9.53718H95.215V7.10743H100.67V4.84297H95.215V2.49586H101.413V0.231396ZM102.083 0.231396H104.859L107.223 8.38015L108.925 2.74379L108.116 0.231396H110.843L113.19 8.09916L115.487 0.231396H118.066L114.479 11.8016H111.835L110.066 6.29751L108.314 11.8016H105.669L102.083 0.231396Z"/>
    </svg>
    </div>
  `;
}

function adInfoButtonCss() {
  if (document.getElementById("ad-info-style")) {
    return;
  }
  const styleTag = document.createElement("style");
  styleTag.id = "ad-info-style";
  const cssString = `
    .ad-info_button {
    background: none;
    border: none;
    position: absolute;
    top: -1em;
    right: 4px;
    cursor: pointer;
    padding: 0;
    font-size: 2em;
    line-height: 1em;
    width: 18px;
    }
  `;

  styleTag.appendChild(document.createTextNode(cssString));
  window.document.head.appendChild(styleTag);
}

function getAdInfoDialogCss() {
  return `
  .ad-info_dialog-modal {
    box-sizing: content-box;
    max-width: 400px;
    width: 400px;
    margin: 92px auto auto;
    border-radius: 2px;
    border: none;
    background: rgb(255, 255, 255); ${''/* #FFFFFF */}
    min-width: 300px;
    color: rgb(0, 0, 0); ${''/* #000 */}
    color-scheme: light;
    padding: 0;
  }

  .ad-info_dialog-modal-padding {
    padding: 64px 40px 64px 40px;
  }

  .ad-info_dialog-modal h2.ad-info_dialog-header {
    font: normal 400 22px/31.68px "Georgia", sans-serif;
    letter-spacing: normal;
    padding-bottom: 0;
    margin-top: 0;
    color: inherit;
  }

  .ad-info_dialog-modal .ad-info_dialog-text {
    font: normal 400 16px/24px "inter V", sans-serif;
    margin: 16px 0;
    color: inherit;
  }

  .ad-info_dialog-modal .ad-info_dialog-text-small {
    font: normal 400 12px/14.5px "inter ", sans-serif;
    margin: 16px 0;
    color: inherit;
  }

  .ad-info_dialog-modal .ad-info_dialog-link {
    font: normal 400 16px/24px "inter V", sans-serif;
    text-decoration: underline;
    color: rgb(10, 107, 163); ${''/* #0A6BA3 */}
    display: flex;
    align-items: center;
    max-width: fit-content;
  }

  .ad-info_dialog-modal section:first-of-type {
    margin-bottom: 30px;
  }

  .ad-info_dialog-modal .ad-info_dialog-button {
    background: rgb(34, 34, 34); ${''/* #222222 */}
    border-radius: 60px;
    border: none;
    color: rgb(255, 255, 255); ${''/* #FFFFFF */}
    font: normal 400 16px/24px "inter", sans-serif;
    padding: 12px 24px;
    cursor: pointer;
    letter-spacing: -1%;
    margin-top: 0.5rem;
  }

  .ad-info_dialog-modal .ad-info_dialog-cancel-button {
    position: absolute;
    right: 15px;
    top: 15px;
    background: rgb(255, 255, 255); ${''/* #FFFFFF */}
    border: none;
    font-weight: bold;
    cursor: pointer;
    padding: 5px;
  }

  .ad-info_dialog-cancel-button svg path {
    fill: rgb(28, 27, 31); ${''/* #1C1B1F */} 
  }

  .ad-info_dialog-modal .ad-info_dialog-logo {
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 128px;
  }

  .ad-info_dialog-logo path {
    fill: rgb(0, 0, 0); ${''/* #000 */}
  }

  .ad-info_dialog-modal form div {
    padding: 12px 16px 12px 16px;
    accent-color: rgb(34, 34, 34); ${''/* #222222 */}
    display: flex;
    align-items: start;
  }

  .ad-info_dialog-modal input {
    height: 32px;
    width: 32px;
    margin-right: 10px;
    margin-top: 0;
    max-width: 15%;
    min-width: 32px;
  }

  .ad-info_dialog-modal label {
    font: normal 400 16px "inter V", sans-serif;
    color: rgb(34, 34, 34); ${''/* #222222 */}
    max-width: 85%;
  }

  .ad-info_dialog-modal form > div > label > p,
  .ad-info_dialog-modal form > div > label > p.ad-info_dialog-text-small {
    margin: 0;
    color: inherit;
  }


  .ad-info_dialog_external_symbol {
    display: flex;
    align-items: baseline;
    margin-left: 10px;
  }

  .ad-info_dialog_external_link {
  }


  @media only screen and (max-width: 600px) {
    .ad-info_dialog-modal {
      box-sizing: border-box;
      max-width: calc(100% - 32px);
      margin: auto;
    }
  }

  @media (prefers-color-scheme: dark) {
    .ad-info_dialog-modal {
      background: rgb(16, 16, 16); ${''/* #101010 */}
      color: rgb(240, 240, 240); ${''/* #F0F0F0 */}
      color-scheme: dark;
    }

    .ad-info_dialog-modal .ad-info_dialog-link {
      color: rgb(90, 187, 243); ${''/* #5ABBF3 */}
    }
  
    .ad-info_dialog-modal .ad-info_dialog-button {
      background: rgb(240, 240, 240); ${''/* #F0F0F0 */}
      color: rgb(16, 16, 16); ${''/* #101010 */}
    }

    .ad-info_dialog-modal .ad-info_dialog-cancel-button {
      background: rgb(16, 16, 16); ${''/* #101010 */}
    }

    .ad-info_dialog-cancel-button svg path {
      fill: rgb(240, 240, 240); ${''/* #F0F0F0 */}
    }

    .ad-info_dialog-logo path {
      fill: rgb(255, 255, 255); ${''/* #FFF */}
    }

    .ad-info_dialog-modal form > div > label > p,
    .ad-info_dialog-modal form > div > label > p.ad-info_dialog-text-small {
      color: rgb(240, 240, 240); ${''/* #F0F0F0 */}
    }
  }
  `;
}

export {
  getAdInfoDialog,
  getAdInfoReportDialog,
  getReportSuccessDialog,
  getAdInfoDialogCss,
  adInfoButtonCss,
};
